<template>
  <div id="weekends">
    <div class="d-flex justify-content-start align-items-start mb-4 w-100" :class="isPhone ? 'mt-5' : ''">
      <div class="back-button d-flex align-items-center justify-content-center" :class="isPhone ? 'ml-3' : 'ml-5'" @click="close()">
        <img src="../../images/arrow-left-small.svg" alt="Back" style="width: 15px; height: 17.5px;" />
      </div>
    </div>
    <div class="top-banner w-100">
      <div class="image-gradient-bottom"></div>
      <div class="top-banner-content">
        <p :class="isPhone ? 'merriweather-reg-32' : 'merriweather-reg-40'">Nos weekends</p>
        <p :class="isPhone ? 'merriweather-light-reg-18' : 'merriweather-light-reg-26'">Des week-ends pour s’évader, se retrouver, respirer.</p>
      </div> 
    </div>
    <div class="weekends-layout w-100" :class="isPhone ? 'pt-3' : 'pt-5'">
      <div class="weekends-sidebar" :class="isPhone ? 'px-3 pt-3' : ''">
        <div
          v-for="(section, idx) in sectionNames"
          :key="section"
          :class="['sidebar-section text-uppercase', 'raleway-bold-p15', { active: idx === activeSectionIndex }]"
          :style="section === 'D\'autres inspirations week-end' ? { minWidth: '180px' } : {}"
          @click="activeSectionIndex = idx"
        >
          {{ section }}
        </div>
      </div>
      <div class="weekends-content pt-5">
        <div class="w-100">
          <div
            v-for="(section, idx) in sectionNames"
            :key="section"
            v-show="idx === activeSectionIndex"
          >
            <SectionBlock
              :title="sectionTitles[idx]"
              :subtitle="sectionSubtitles[idx]"
              :description="sectionDescriptions[idx]"
              :weekends="selectedWeekends"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="w-100 pb-5">
      <AccommodationCard 
        v-if="!isPhone"
        :user="this.user"
        :lodgings="accommodations"
        :buttonText="'Découvrir toutes les nouveautés'"
        @collectionSelected="selectedCollection = $event"
      />
      <AccommodationPhoneCard v-else :user='user' :lodgings="accommodations" :buttonText="'Découvrir toutes les nouveautés'" @collectionSelected="selectedCollection = $event"></AccommodationPhoneCard>
    </div>
  </div>
</template>

<script>
import AOS from "aos";
import SectionBlock from "./SectionBlock.vue";
import AccommodationCard from "components/cards/AccommodationCard.vue";
import AccommodationPhoneCard from "components/cards/AccommodationPhoneCard.vue";
import fetcher from "packs/shared/api.js";

export default {
  name: "weekendall",
  props: ["weekends", "user"],
  components: { SectionBlock, AccommodationCard, AccommodationPhoneCard },
  data() {
    return {
      showBanner: false,
      weekendsMounted: [],
      activeSectionIndex: 0,
      sectionNames: [
        "Parenthèses amoureuses",
        "Bulles de détente",
        "Au cœur de la nature",
        "Voyages gourmands",
        "D'autres inspirations week-end"
      ],
      sectionTitles: [
        "Parenthèse",
        "Bulle",
        "Au coeur",
        "Voyages",
        "D'Autres inspirations",
      ],
      sectionSubtitles: [
        "amoureuse",
        "de détente",
        "de la nature",
        "gourmands",
        "weekend",
      ],
      groupedWeekends: [
        ["romantique", "amoureux"],
        ["detente", "bien-etre", "thalasso", "spa"],
        ["nature", "mer", "montagne"],
        ["gourmand", "oenologique"],
        ["city-break", "culturel", "famille", "insolite"]
      ],
      selectedWeekends: [] ,
      weekendsMounted: this.weekends,
      accommodations: [],  
      selectedCollection: null
    };
  },
  methods: {
    close() {
      window.history.back();
    },
    groupWeekendBySection() {
      this.selectedWeekends = this.weekendsMounted.filter(coll =>
        this.groupedWeekends[this.activeSectionIndex]?.includes(coll.slug)
      );
    },
    async fetchHomeLoadings() {
      const responseAccommodation = await fetcher.get(
          "/home_lodgings", {
            params: { collection: this.selectedCollection }
          }
        );
      this.accommodations = responseAccommodation.data;
    },
  },
  computed: {
    isPhone() {
      return /Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent);
    },
    sectionDescriptions() {
      return [
        `Offrez-vous un week-end à deux, avec nos <span class="${ this.isPhone ? 'merriweather-light-italic-18' : 'merriweather-light-italic-24' }">privilèges exclusifs</span>`,
        `Week-ends bien-être et <span class="${ this.isPhone ? 'merriweather-light-italic-18' : 'merriweather-light-italic-24' }">privilèges exclusifs</span>, juste pour vous`,
        `Retours à l’essentiel et <span class="${ this.isPhone ? 'merriweather-light-italic-18' : 'merriweather-light-italic-24' }">privilèges exclusifs</span>, vivez l’exception`,
        `Saveurs d’exception et <span class="${ this.isPhone ? 'merriweather-light-italic-18' : 'merriweather-light-italic-24' }">privilèges exclusifs</span>, pour une expérience unique`,
        `Chaque week-end, une nouvelle parenthèse, avec des <span class="${ this.isPhone ? 'merriweather-light-italic-18' : 'merriweather-light-italic-24' }">privilèges exclusifs</span> rien que pour vous.`
      ];
    }
  },
  watch: {
    activeSectionIndex() {
      this.groupWeekendBySection();
    },
    selectedCollection() {
      this.fetchHomeLoadings();
    }
  },
  mounted() {
    AOS.init({
      duration: 1200,
      once: true,
    });
    this.fetchHomeLoadings();
    this.groupWeekendBySection();
  },
};
</script>

<style lang="scss" scoped>
#weekends {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;

  .top-banner {
    height: 420px;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    background-image: url('https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/week-end-hortense.webp');
    background-size: cover;

    .top-banner-content {
      width: 100%;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      text-align: center;
      color: #F7F7F7;
    }

    .image-gradient-bottom {
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%;
      height: 115%;
      background: linear-gradient(to top, rgba(0, 0, 0, 0.2), transparent);
      pointer-events: none;
    }
  }
}
.weekends-layout {
  display: flex;
  min-height: 100vh;
}
.weekends-sidebar {
  width: 350px;
  background: #fff;
  border-right: 1px solid #BFBFBF;
  padding: 88px 93px 88px 64px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  min-height: 100vh;
  gap: 56px;
}
.sidebar-section {
  cursor: pointer;
  font-family: "Raleway", sans-serif;
  font-weight: 700;
  font-size: 15px;
  color: #000000B2;

  &:hover {
    color: black;
  }
}
.sidebar-section.active {
  color: black;
  border-bottom: 1.5px solid #3B6152;
  padding-bottom: 2px;
}
.weekends-content {
  flex: 1;
  padding: 0 0 0 0;
}
.section-block {
  margin-bottom: 60px;
}

.back-button {
  width: 33px;
  height: 33px;
  background: #BFBFBF;
  border-radius: 8.25px;
  z-index: 1;
  top: 0;
  position: relative;
}

@media (max-width: 768px) {
  .weekends-layout {
    flex-direction: column;
  }
  .weekends-sidebar {
    width: 100%;
    flex-direction: row;
    border-right: none;
    padding: 0 0 0 0;
    min-height: unset;
    justify-content: flex-start;
    gap: 5px;
    overflow-x: auto;
  }
  .sidebar-section {
    min-width: 120px;
    text-align: center;
    min-height: 50px;
  }
  .sidebar-section.active {
    border-bottom: 1.5px solid #3b6152;
    border-left: none;
    padding-bottom: 2px;
  }
  .weekends-content {
    padding: 0;
  }

  .top-banner {
    height: 368px;
    background-position: center;

    .top-banner-content {
      padding: 40px;
    }
  }

  .back-button {
    margin-top: 85px;
  }
}

</style>
